import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import { MenuDrawer } from './MenuDrawer';
import { Colors } from '../utils/Colors';

import Logo from '../assets/OCDfeat_logo.png';

export function NavBar() {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" sx={{ bgcolor: Colors.ocdWhite }}>
        <Toolbar>
          <Link to="/dashboard">
            <img
              src={Logo}
              style={{ height: 70, padding: '15px' }}
              alt="logo"
            />
          </Link>
          <Typography variant="h3" component="div" sx={{ flexGrow: 1 }} />
          <MenuDrawer />
        </Toolbar>
      </AppBar>
    </Box>
  );
}
